<template>
    <svg aria-hidden="true" focusable="false" width="25" height="27" viewBox="0 0 25 27" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M17.2027 8.21371C17.2027 10.8376 15.0757 12.9646 12.4518 12.9646C9.82793 12.9646 7.70087 10.8376 7.70087 8.21371C7.70087 5.58984 9.82793 3.46277 12.4518 3.46277C15.0757 3.46277 17.2027 5.58984 17.2027 8.21371Z"
            class="stroke fill-active-red"
            stroke="black"
            stroke-miterlimit="10" />
        <path
            d="M21.1154 25.5669H3.89116C3.68096 25.5669 3.50438 25.3959 3.5 25.1783V19.096C3.5 17.3858 4.88623 16.005 6.59104 16.005H18.409C20.1192 16.005 21.5 17.3912 21.5 19.096V25.1823C21.5 25.3947 21.3278 25.5669 21.1154 25.5669Z"
            class="stroke fill-active-red"
            stroke="black"
            stroke-miterlimit="10" />
    </svg>
</template>
